import { render, staticRenderFns } from "./Series.vue?vue&type=template&id=ef8c88ba&"
import script from "./Series.vue?vue&type=script&lang=js&"
export * from "./Series.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports